export enum ProductType {
    Generic = 'generic',
    Channel = 'channel',
    Episode = 'episode',
    LiveEvent = 'live-event',
}

export enum LiveEventStatus {
    Cancelled = 'cancelled',
    Delayed = 'delayed',
    Finished = 'finished',
    Live = 'live',
    OnSchedule = 'on-schedule',
}
